import styled from 'styled-components';

export const InputContainer = styled.div`
display: flex;
gap:16px;
`;

export const FormWrapper = styled.form`
  display: flex;
flex-direction: column;
gap: 16px;
width: 100%;
`;
